// extracted by mini-css-extract-plugin
module.exports = {"submit":"styles-module__submit___MRpC5"};